import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  IOdbBillCategoryDetail,
  IOdbCoverDetailDivisionSummaryCategories,
  IDates,
  IOdbBillCategoryDetailSection,
} from '@dch/billing-business-logic';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../../services/utils.service';
import { SelectedOdbDetailsInfo } from '../../models/pii.model';
import { ONE_DIGITAL_BILL_USAGE_DET_L3_PAGE } from '../../config/my-bill.constants';
import { OnDestroyHookDirective } from '../../common/hooks';
import { ApplicationState } from 'src/app/state/reducers';
import { Store } from '@ngrx/store';

@Component({
  selector: 'my-bill-odb-category-sections',
  templateUrl: './odb-category-sections.component.html',
  standalone: false,
})
export class OdbCategorySectionsComponent extends OnDestroyHookDirective {
  @Input() category?: keyof IOdbCoverDetailDivisionSummaryCategories;
  @Input() sections: IOdbBillCategoryDetail['sections'];
  @Input() billingAccountNumber: string;
  @Input() documentReference: string;
  @Input() categoryDetailValidFor?: IDates;
  @Input() productSplitIdentifier?: string;

  isStaySignedIn = false;

  constructor(
    private router: Router,
    private store: Store<ApplicationState>,
    private utilsService: UtilsService
  ) {
    super();
  }

  isFirstOutOfPackSectionAfterInPackSection(
    sections: IOdbBillCategoryDetail['sections'],
    index: number
  ): boolean {
    return (
      index !== 0 &&
      Boolean(sections[index - 1].isPack) &&
      sections[index].isPack === false
    );
  }

  onUsageSectionClick(
    section: IOdbBillCategoryDetailSection,
    sectionIndex: string
  ) {
    this.utilsService.setValueInSessionStorage<SelectedOdbDetailsInfo>(
      ODB_DETAILS_SESSION_DATA_KEY,
      {
        ...this.utilsService.getInfoFromSessionStorage<SelectedOdbDetailsInfo>(
          ODB_DETAILS_SESSION_DATA_KEY
        ),
        selectedSection: section,
        selectedSectionProductSplitIdentifier: this.productSplitIdentifier,
        selectedSectionItemIdentifier: (
          this.productSplitIdentifier + sectionIndex
        ).replace(/\s/g, ''),
      }
    );
    this.router.navigate([ONE_DIGITAL_BILL_USAGE_DET_L3_PAGE]);
  }
}
